export default __webpack_public_path__ + "static/media/temazcal.b8b5bf0f.jpg";